export enum LoadingSpinnerDisplayMode {
    INLINE = 'Inline',
    BLOCK = 'Block'
}

export enum LoadingSpinnerColorScheme {
    AP_BLUE = 'Blue',
    AP_GREEN = 'Green',
    WHITE = 'White'
}

export enum LoadingSpinnerPosition {
    START = 'Start',
    END = 'End',
    CENTER = ''
}

export enum LoadingSpinnerSize {
    SMALL = 'Small',
    MEDIUM = 'Medium',
    LARGE = 'Large'
}

export enum LoadingSpinnerDefaultHeight {
    NONE = '',
    SMALL = 'Small',
    MEDIUM = 'Medium',
    LARGE = 'Large'
}